export default class {
    
    constructor(photoSwipeContainer) {
        this.getNewPhotoSwipe = photoSwipeContainer.getNewPhotoSwipe;
        this.lightBoxBindingRegister = {};
    }

    init() {
        // initial lightbox binding
        const previewAreas = document.querySelectorAll('.preview-area');
        previewAreas.forEach((previewArea) => {
            const items = previewArea.querySelectorAll('.items');
            items.forEach((item) => {
                this.bindLightBox(item)
                this.setupObserver(item);
            });
        });
    }

    buildOptions(theNode) {
        let dataSource = [];
    
        const lightboxImages = theNode.querySelectorAll('a.files-wrapper');
    
        lightboxImages.forEach((element) => {
            let src = element.href;
    
            dataSource.push({
                src: src,
                 // the element is setup in the `_generateSingleFilePreview` function inside cc-file-upload.js
                width: element.getAttribute('data-pswp-width'),
                height: element.getAttribute('data-pswp-height'),
                type: element.getAttribute('data-pswp-type')
            });
        });
    
        return {
            dataSource: dataSource,
            showHideAnimationType: 'none'
        };
    
    };


    bindLightBox(theNode) {
        const options = this.buildOptions(theNode);
        const lightboxImages = theNode.querySelectorAll('a.files-wrapper');
        lightboxImages.forEach((element, index) => {
            // remove previous binding
            if (this.lightBoxBindingRegister[element.id]) {
                element.removeEventListener("click", this.lightBoxBindingRegister[element.id]);
            }
            // register binding function
            this.lightBoxBindingRegister[element.id] = this._getlightBoxBindingRegisterFunction(index, options);
            // bind the function to click
            element.addEventListener("click", this.lightBoxBindingRegister[element.id]);
        });
    }

    setupObserver(targetNode){
        // Options for the observer (which mutations to observe)
        const config = { attributes: false, childList: true, subtree: false };

        let that = this;
        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(
            (mutationList, observer) => mutationList.every(
                (mutation) => mutation.type === "childList" && that.bindLightBox(targetNode)
            )
        );
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    }


    _getlightBoxBindingRegisterFunction(index, options) {
        let that = this;
        return function(e) {
            e.preventDefault();
            options.index = index; // defines start slide index
    
            let photoSwipe = that.getNewPhotoSwipe(options);

            photoSwipe.on('contentLoad', (e) => {
                const { content } = e;
                if (content.type == 'video') {
                    e.preventDefault();

                    content.element = document.createElement('div');
                    content.element.className = 'pswp__video_container';

                    const video = document.createElement('video');
                    video.setAttribute('controls', '');
                    video.setAttribute('width', '100%');

                    const source = document.createElement('source');
                    source.setAttribute('src', content.data.src);
                    source.setAttribute('type', that._getVideoContentTypeByUrl(content.data.src));
                    video.appendChild(source);
                    content.element.appendChild(video);
;
                }
            });
    
            photoSwipe.init(); // initializing PhotoSwipe core adds it to DOM
        }

    }

    _getVideoContentTypeByUrl(url) {
        // get the extension from url
        let extension = url.split('.').pop();
        // check if it is a video
        if (['mp4', 'webm', 'ogg'].includes(extension)) {
            // return content type loke video/mp4
            return `video/${extension}`;
            
        } else {
            return false;
        }
    }

}